/* eslint-disable */
import React, { useState, useContext } from "react";
import { FaWindowClose } from "react-icons/fa";
import { Card, CardBody } from "reactstrap";
import { ApiContext } from "../apiContext";
import { getToken } from "../../auth/AuthService";
import axios from "axios";
import { v4 as uuidv4 } from "uuid";
import AddForm from "./AddForm";
import notify from "../../helper/Notify";
import { useLoader } from "../../helper/Loader";
import { isSpecialCharacter } from "../../helper/CommonFunction";
import { imageUpload } from "../ImageUpload";

const Service = ({ closeModal, modalData, setModalData }) => {
  const { data, error, setData } = useContext(ApiContext);
  const [formError, setFormError] = useState({});
  const [contentError, setContentError] = useState(null);
  const {setIsLoader} = useLoader();
  const [dataSave, setDataSave] = useState({})
  const apiBaseUrl = window.API_CONFIG.All_Api.investor;
  const token = getToken();
  const generateUUID = () => {
    const uuid = uuidv4();
    const fiveDigitUUID = uuid.replace(/-/g, "").substr(0, 5);
    return fiveDigitUUID;
  };
  const [addCase, setCase] = useState({
    title: "",
    description: "",
    status: false,
    accordions: [
    {
      title: "",
      documents: [
        { name: "", file: null }
      ]
    }
  ],
    code: generateUUID(),
  });


  const getInputValue = (field) => {
    return modalData ? modalData[field] : addCase[field];
  };

  const handleInputChange = (event, field) => {
  const { value } = event.target;

  if (modalData) {
    setModalData((prev) => ({
      ...prev,
      [field]: value,
    }));
  } else {
    setCase((prev) => ({
      ...prev,
      [field]: value,
    }));
  }
};


  const validateFormFields = () => {
    const errors = {};
    const fieldarr = ["title"];
    const validatefield = (field) => {
      if (!modalData && addCase[field] === "") {
        errors[field] = `${
          field.charAt(0).toUpperCase() + field.slice(1)
        } is required.`;
      }
      if (modalData && modalData[field] === "") {
        errors[field] = `${
          field.charAt(0).toUpperCase() + field.slice(1)
        } is required.`;
    }
    };
    fieldarr.forEach(validatefield);

    return errors;
  };
  const handleClear = () => {
    const clearfields = {
      title: "",
     description: "",
    status: false,
     accordions: [
    {
      title: "",
      documents: [
        { name: "", file: null }
      ]
    }
  ],
    };
    if (!modalData) {
      setCase(clearfields);
    } else {
      setModalData((prevModalData) => ({
        ...prevModalData,
        ...clearfields,
      }));
    }
  };

  
  const handleSubmit = async (event) => {
    event.preventDefault();
    const formErrors = validateFormFields();

    if (Object.keys(formErrors).length > 0) {
      setFormError(formErrors);
      notify.warning();
      return; // Stop form submission if there are validation errors
    }

    setFormError(""); // Clear form errors if there are no validation errors
    setIsLoader(true)
    try {
      if (modalData) {
        const updatedModalData = { ...modalData, ...dataSave };
        const updatedData = {
          ...updatedModalData,
          updatedDate: new Date().toISOString().slice(0, 10),
            accordions: modalData.accordions || [],
        };

        try {
          const response = await axios.get(apiBaseUrl, {
            headers: {
              "x-access-token": token,
            },
          });

          const careerData = response.data.data?.ViewModels || [];
          const updatedCareerData = careerData.map((item) =>
            item.code === modalData.code ? { ...item, ...updatedData } : item
          );
          const duplicateItem = careerData.find(
            (item) =>
              item.title === modalData.title && item.code !== modalData.code
          );

          if (duplicateItem) {
            notify.error("Data is a duplicate and cannot be updated.");
            return;
          }

          if(contentError){
            notify.error(contentError);
            return;
          }

          if (isSpecialCharacter(modalData.title.charAt(0))){
            notify.error("Name should not start with special character");
               return;
          }

          const updateResponse = await axios.post(
            apiBaseUrl,
            { ViewModels: updatedCareerData },
            {
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                "x-access-token": token,
              },
            }
          );
          console.log("Data successfully updated:", updateResponse.data);
          console.log(updatedCareerData)
          if(updateResponse.data.success === true){
          setData((prevData) => ({
            ...prevData,
            investor: updatedCareerData,
          }));
          notify.success(updateResponse.data.message);
          closeModal();

          setCase({}); 
        }
        else{

          notify.error(updateResponse.data.message);
        }
        } catch (error) {
          console.error("Error updating data:", error);
          notify.error(error.message);
        }
      } else {
        // Adding a new data entry
        const updatedBlogData = {
          ...addCase,
           accordions: addCase.accordions || [],
          createdDate: new Date().toISOString().slice(0, 10),
        };

        try {
          const response = await axios.get(apiBaseUrl, {
            headers: {
              "x-access-token": token,
            },
          });

          const oldData = response.data.data?.ViewModels || [];
          const duplicateItem = oldData.find(
            (item) => item.title === addCase.title
          );

          if (duplicateItem) {
            notify.error("Data is a duplicate and cannot be added.");
            return;
          }

          if(contentError){
            notify.error(contentError);
            return;
          }

          if (isSpecialCharacter(addCase.title.charAt(0))){
            notify.error("Name should not start with special character");
               return;
          }

          const updatedData = [...oldData, updatedBlogData];

          const addResponse = await axios.post(
            apiBaseUrl,
            { ViewModels: updatedData },
            {
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                "x-access-token": token,
              },
            }
          );

          console.log("New data added successfully:", addResponse.data);
          if(addResponse.data.success === true){
          setData((prevData) => ({
            ...prevData,
            investor: updatedData,
          }));

          closeModal();
          notify.success(addResponse.data.message);

          setCase({}); 
        }
        else{
          notify.error(addResponse.data.message);
        }
        } catch (error) {
          console.error("Error adding new data:", error);
          notify.error(error.message);
        }
      }
    } catch (error) {
      console.error("Error occurred:", error);
      notify.error("Error occurred. Please try again.");
    }
    finally{
      setIsLoader(false)
    }
  };

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  return (
    <>
      <div className="modal-wrapper"></div>
      <div className="modal-container">
        <div className="modal-head">
          <h1>{modalData ? "Edit Investor" : "Add New Investor"}</h1>
          <div className="close-icon">
            <FaWindowClose onClick={closeModal} />
          </div>
        </div>
        <div className="modal-body">
          <Card>
            <CardBody>
              <AddForm
  handleSubmit={handleSubmit}
  formError={formError}
  getInputValue={getInputValue}
  handleInputChange={handleInputChange}
  handleClear={handleClear}

  modalData={modalData}
  addCase={addCase}
 updateSource={modalData ? setModalData : setCase}
 accordions={(modalData || addCase).accordions}
/>
            </CardBody>
            <div className="avc"></div>
          </Card>
        </div>
      </div>
    </>
  );
};

export default Service;
